<template>
  <transition name="van-fade">
    <div @click="cancelHandler" @touchmove.prevent class="mask" v-show="show">
      <div @click.stop class="dialog">
        <div class="msg" v-show="showMsg">
          <slot name="msg"></slot>
        </div>
        <slot></slot>
        <div :class="{'btn-round': btnRound}" class="function-buttons">
          <button @click="cancelHandler" class="cancel" v-show="showCancel">{{cancelText}}</button>
          <button @click="confrimHandler" class="confrim" v-show="showConfrim">{{confrimText}}</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'dialogs',
  model: {
    prop: 'show'
  },
  props: {
    show: {
      type: Boolean
    },
    showMsg: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showConfrim: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '再想想'
    },
    confrimText: {
      type: String,
      default: '确定'
    },
    btnRound: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancelHandler () {
      this.$emit('cancel-handler', false)
    },
    confrimHandler () {
      this.$emit('confrim-handler', false)
    }
  }
}
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999;
  .flex-center;
}
.dialog {
  width: 6.3rem;
  border-radius: 0.14rem;
  background-color: #fff;
  font-size: @fz32;
  color: @base;
  padding-bottom: 0.5rem;
  .msg {
    text-align: center;
    padding: 1.16rem 0 0.94rem;
  }
  .function-buttons,
  .btn-round {
    padding: 0 0.3rem;
    .flex-around;
    button {
      width: 2rem;
      height: 0.8rem;
      font-size: @fz32;
      border-radius: 0.08rem;
    }
    .cancel {
      color: @base;
      background-color: #f0f0f0;
    }
    .confrim {
      color: #fff;
      background-color: #ff2851;
    }
  }
  .btn-round {
    button {
      border-radius: 30px;
    }
  }
}
</style>
